<template>
    <div id="back" class="">
      <div class="color-bar"></div>
  
      <div class="nav-bar">
        <img src="@/assets/wellen-logo.svg" width="200px" style="width:200px;" alt="Wellen Park Logo" />
      </div>
      <!-- <div class="nav-bar" style="width:100px;">
        <a id="backIcon" href="#"><font-awesome-icon icon="chevron-left" /></a>
      </div> -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'NavbarComponent',
  };
  </script>
  
  <style scoped>
  #back {
    position: absolute;
    z-index: 2;
    transition: top 0.5s;
    top: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 85px;
    z-index: 1000;
    box-shadow: 0 2px 13px 0 rgba(0,0,0,0.39);
  }
  
  #back.hide {
    top: -200px;
  }
  
  #back a {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75em;
    margin: 10px;
  }
  
  .color-bar {
    border-top: 0.75rem solid;
    padding: 0;
    border-image: linear-gradient(
        to right,
        rgba(0, 100, 163, 1) 14.28%,
        rgba(0, 178, 221, 1) 14.28%,
        rgba(0, 178, 221, 1) 28.57%,
        rgba(199, 233, 244, 1) 28.57%,
        rgba(199, 233, 244, 1) 42.855%,
        rgba(241, 201, 119, 1) 42.855%,
        rgba(241, 201, 119, 1) 57.14%,
        rgba(26, 46, 87, 1) 57.14%,
        rgba(26, 46, 87, 1) 71.427%,
        rgba(243, 190, 169, 1) 71.427%,
        rgba(243, 190, 169, 1) 85.71%,
        rgba(240, 44, 46, 1) 85.71%
      )
      7;
  }
  
  .nav-bar {
    position: absolute;
    width: 100%;
    color: rgba(0,98,167,1);
  }
  
  #backIcon {
    left: 0;
    color: rgba(0,98,167,1);
  }
  
  .nav-bar img {
    position: relative;
    left: 50%;
    margin: 13px;
    margin-left: -100px;
  }
  </style>
  